module.exports = __webpack_public_path__ + "media/src/images/icons/gray-chevron-up-d07bc4b9467976bb8e6af831bd4093c5.svg";